// extracted by mini-css-extract-plugin
module.exports = {"summary":"Days_summary__2kjVG"};